import { BaseViewModel } from "../../../../common/BaseViewModel";
import * as Format from "../../../../common/FormatFunctions";
import { CloudService } from "../../../../common/CloudService/ClientLibsReference";
import { CrudlStatus } from "../../../../common/config/AppConstants";
import * as ApiService from "../../../../common/CloudService/ApiService";
export class FlowViewModel extends BaseViewModel {
  constructor(updateState, showError, showSuccess) {
    super();
    this.updateState = updateState;
    this.showError = showError;
    this.showSuccess = showSuccess;
  }

  updateFLow = () => {};
  deleteFlow = () => {};

  getLocalBean = (partList, productList) => {
    var flowBeanSaved = localStorage.getItem("flowBean");

    if (Format.isNotNull(flowBeanSaved)) {
      var flowBeanSavedLocal = JSON.parse(flowBeanSaved);
      this.logger.info(flowBeanSavedLocal);
      var loadedFlowBean = this.renderPartsAndProductsFromJson(
        flowBeanSavedLocal,
        partList,
        productList
      );
      this.logger.info(loadedFlowBean);
      return loadedFlowBean;
    }
  };
}



// WEBPACK FOOTER //
// ./src/components/Flows/legacy/Wizard/FlowViewModel.js